import React, {useEffect, useState} from 'react';
import {useMutation} from '@tanstack/react-query';
import {createSignUp, getUserInfo, sendContactEmail} from '../library/api';
import {useRecoilValue} from 'recoil';
import {verifyInfoState} from '../library/recoil/atoms/verifyInfoState';

const Inquiry = () => {
    const regEmail = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;

    const verifyInfo = useRecoilValue(verifyInfoState);
    const [value, setValue] = useState({
        senderName: verifyInfo?.partners_nm,
        senderEmail: '',
        subject: '',
        content: '',
    });
    // 퍄트너스 회원 정보 가져오기
    const {mutate: getUserInfoMutate} = useMutation({
        mutationFn: getUserInfo,
        mutationKey: ['getUserInfo'],
        onSuccess: data => {
            const items = {
                senderName: verifyInfo?.partners_nm,
                senderEmail: !data?.email_addr ? verifyInfo?.partners_id : data?.email_addr,
                subject: '',
                content: '',
            };
            setValue(items);
        },
        onError: error => {
            if (error.response.data.code !== 401) {
                alert(error.response.data.message);
            }
            throw error;
        }
    });


    // 퍄트너스 문의하기(문의 메일 발송)
    const {mutate: sendContactEmailMutate} = useMutation({
        mutationFn: sendContactEmail,
        mutationKey: ['sendContactEmail'],
        onSuccess: data => {
            if (data.done) {
                alert('문의하신 내용이 정상적으로 접수되었습니다.');
                getUserInfoMutate();
                return;
            }
        },
        onError: error => {
            if (error.response.data.code !== 401) {
                alert(error.response.data.message);
            }
            throw error;
        }
    });
    const handleSubmit = (event) => {
        event.preventDefault();
        if (!value.senderName) {
            alert('이름을 입력해주세요');
            return;
        }
        if (!value.senderEmail) {
            alert('이메일을 입력해주세요');
            return;
        }
        if (!value.subject) {
            alert('문의 제목을 입력해주세요');
            return;
        }
        if (!value.content) {
            alert('문의 내용을 입력해주세요');
            return;
        }
        sendContactEmailMutate(value);

    };

    useEffect(() => {
        getUserInfoMutate();
    }, []);
    return (
        <main className="flex-grow container mx-auto px-4 py-8 sm:py-16">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-2xl sm:text-3xl font-bold mb-10">문의하기</h1>
                <div className="border-b-2 border-teal-500 mb-7"></div>
                <form id="joinForm" onSubmit={handleSubmit}>
                    <div className="w-full mb-5 flex gap-x-5  items-start sm:flex-row flex-col gap-y-5">
                        <input type="text" placeholder="이름" value={value?.senderName}
                               className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-teal-500"
                               onChange={e => {
                                   setValue(prevState => ({...prevState, senderName: e.target.value}));
                               }}/>
                        <div className="flex flex-col items-start w-full">

                            <input type="email" placeholder="이메일" value={value?.senderEmail}
                                   className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-teal-500"
                                   onChange={e => {
                                       setValue(prevState => ({...prevState, senderEmail: e.target.value}));
                                   }}/>
                            {
                                value.senderEmail !== '' && !regEmail.test(value.senderEmail) &&
                                <p className={`text-red-500 mt-1 text-xs sm:text-sm  bottom-[-22px]`}>이메일을
                                    정확히
                                    입력해주세요.</p>
                            }
                        </div>
                    </div>

                    <div className="w-full mb-5">
                        <input type="text" placeholder="문의 제목" value={value?.subject} maxLength="100"
                               className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-teal-500"
                               onChange={e => {
                                   setValue(prevState => ({...prevState, subject: e.target.value}));
                               }}/>
                    </div>
                    <div>
                        <textarea placeholder="문의내용을 입력해 주세요." rows="15" maxLength="3000"
                                  className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-[10px] resize-none focus:outline-none focus:ring-2 focus:ring-teal-500"
                                  onChange={e => {
                                      setValue(prevState => ({...prevState, content: e.target.value}));
                                  }} value={value?.content || ''}></textarea>
                    </div>
                    <div className="border-b-2 border-white  mb-[40px]"></div>
                    <div className="text-center">
                        <button type="submit"
                                className="bg-teal-500 text-white sm:px-[66px] px-8 sm:py-4 py-2 rounded-[30px] hover:bg-teal-600 transition duration-300 text-lg font-extrabold sm:text-base">문의하기
                        </button>
                    </div>
                </form>
            </div>
        </main>
    );
};

export default Inquiry;
